<template>
  <div>
    <Modal :footer-hide="true" :mask-closable="false" v-model="show" :title="row.orgName" :width="1000" @on-cancel="$emit('cancel')">
      <table class="QHtable" v-if="!$isblank(row)">
        <tr>
          <th style="width: 125px">单位信息</th>
          <th></th>
        </tr>
        <tr>
          <td style="width: 125px"><b>运输单位</b></td>
          <td>
            <span> {{ row.orgName }}</span>
          </td>
        </tr>
        <tr>
          <td style="width: 125px"><b>通讯地址</b></td>
          <td>{{ row.org.addressFull }}</td>
        </tr>
        <tr>
          <td style="width: 125px"><b>联系姓名</b></td>
          <td>{{ row.org.contactName }}</td>
        </tr>
        <tr>
          <td style="width: 125px"><b>联系电话</b></td>
          <td>{{ row.org.contactTel }}</td>
        </tr>
        <tr>
          <th style="width: 125px">运输权限</th>
          <th></th>
        </tr>
        <tr>
          <td style="width: 125px"><b>运输区域</b></td>
          <td>
            <span> {{ row.authAreaNameFull }}</span>
          </td>
        </tr>
        <tr>
          <td style="width: 125px"><b>卸车许可</b></td>
          <td v-if="!$isblank(row.canUnloadCar)">
            <span v-if="row.canUnloadCar == 100">仅自己接收（清运司机只能运输到自己单位,不能运输到三方接收点）</span>
            <span v-if="row.canUnloadCar == 200">仅三方接收（清运司机只能运输到三方接收点,不能运输到自己单位）</span>
            <span v-if="row.canUnloadCar == 300">自己及三方（清运司机既可运输到自己单位,也可以运输到三方接收点）</span>
          </td>
          <td v-else>
            <span class="CL11"><i class="MR3 iconfont icon-wenhao-quan"></i>未设置运输卸车许可,不可参与运输</span>
          </td>
        </tr>
        <tr>
          <td><b>开通时间</b></td>
          <td>{{ $timeFmt(row.created, "YYYY年MM月DD日 HH分mm秒") }} {{ row.from }}</td>
        </tr>
        <tr>
          <th style="width: 125px">相关资质</th>
          <th></th>
        </tr>
        <tr v-for="(item, index) in row.orgAllQualification" :key="index">
          <td>
            <b>{{ $s("zizhiTypeTxt", item.zizhiType) || "其他资质" }}</b>
          </td>
          <td>
            <div class="flex-between">
              <div>
                <span class="MR5 CL4" v-if="$isYouxiaoqiNei(item.startTime, item.endTime)"><i class="MR3 iconfont icon-tongyi"></i>有效期内</span>
                <span class="MR5 CL5" v-else><i class="MR3 iconfont icon-wenhao-quan"></i>有效期外</span>
                <span>{{ item.name }}</span>
                <span style="white-space: nowrap">(有效期{{ $timeFmt(item.startTime, "YYYY年MM月DD日") }}至{{ $timeFmt(item.endTime, "YYYY年MM月DD日") }})</span>
              </div>
              <div class="flex-between" style="margin-left: 10px">
                <span class="QHset" style="white-space: nowrap" @click="$openImg($getFritImg(item.url))"> 查看 </span>
              </div>
            </div>
          </td>
        </tr>
        <tr v-if="$isblank(row.orgAllQualification)">
          <td style="text-align: center" colspan="10">暂未完善相关资质</td>
        </tr>
      </table>
    </Modal>
  </div>
</template>
<script>
export default {
  // +----------------------------------------------------------------------
  // | Desc:data
  // +----------------------------------------------------------------------
  data() {
    return {
      Checkbox: true,
      show: false,
      row: {},
    };
  },
  methods: {
    // +----------------------------------------------------------------------
    // | Desc:弹窗详情
    // +----------------------------------------------------------------------
    hiPop(e) {
      //参数整合与接口
      var that = this;
      var https = {
        type: "isRow",
        api: this.$api.getOrgyunshuDetailed,
        parameter: {
          id: e.id,
        },
      };
      this.$httpsApi(https, function (res) {
        that.title = res.data.name;
        that.show = true;
      });
    },
  },
};
</script>
